import { yesNoUI } from 'platform/forms-system/src/js/web-component-patterns';
import { DependentSupportDescription } from '../../../../components/FormDescriptions';
import { DEFAULT_TITLE_OPTS, titleWithNameUI } from '../../../../definitions';
import content from '../../../../locales/en/content.json';
import { strWithYear } from '../../../../utils/helpers';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['dependent-info--support-title'];
const INPUT_LABEL = strWithYear(content['dependent-info--support-label']);

const { receivedSupportLastYear } =
  FULL_SCHEMA.properties.dependents.items.properties;

export default {
  uiSchema: {
    ...titleWithNameUI(TITLE_TEXT, DependentSupportDescription, {
      ...DEFAULT_TITLE_OPTS.dependents,
      possessive: false,
    }),
    receivedSupportLastYear: yesNoUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    properties: { receivedSupportLastYear },
  },
};
